import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { claimPdfJSON } from "../../DynamicFormsJson/Transaction/claimPdfJson";
import { getClaimApply } from "../../Slice/claim.slice";
import { getSalesExecutive } from "../../Slice/salesExecutive.slice";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import jsPDF from "jspdf";
import moment from "moment";
import { imageUrl } from "../../config/Url";
import { downloadF } from "../PDF/PDFDownload";
import endpoint from "../../config/endpoints";

class ClaimPdfMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicMasterData: {
        stockHolderTypeDetail:
          this.props.stakeHolderTypeList?.stockStakeHolderType,
        salesPersonDetail: this.props.salesTeamList?.salesExecutive,
      },
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.stakeHolderTypeList !== nextProps.stakeHolderTypeList) {
      if (
        this.props.stakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }

    if (this.props.salesTeamList !== nextProps.salesTeamList) {
      if (
        this.props.salesTeamList?.salesExecutive !==
        nextProps.salesTeamList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesTeamList?.salesExecutive,
          },
        });
      }
    }
  }

  async componentDidMount() {
    const { showLoador, getStockStakeHolderType, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
        ({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        }
      );
    } else {
      showNotification({
        msg: noInternetMsg,
        severity: "error",
      });
    }
  }

  getListById = async (data) => {
    const { showNotification, showLoador, getSalesExecutive } = this.props;
    if (navigator.onLine) {
      if (data.stockStakeHolderType && data.stockStakeHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutive({
          stockStakeHolderId: data.stockStakeHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = async (data) => {
    const { showLoador, getClaimApply, showNotification } = this.props;

    let salesTeamIds = {
      salesTeamIds: data.salesTeamIds.split(","),
    };

    if (localStorage.getItem("showExcelInsteadOfClaimPdf")
      && localStorage.getItem("showExcelInsteadOfClaimPdf") == 1) {
      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url: endpoint.exportDataNew + "/get-claim-excel-data?fromDate=" + data.fromDate + "&toDate=" + data.toDate,
        ext: "xls",
        postBody: salesTeamIds,
        openNewTab: false,
      }).then((response) => {
        if (!response) {
          showNotification({
            msg: serverMsg,
            severity: "error",
          });
        }
        showLoador({ loador: false });
      });

    } else {
      showLoador({ loador: true });
      await getClaimApply({
        fromDate: data.fromDate,
        toDate: data.toDate,
        salesTeamIds: salesTeamIds,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.generatePDF(response);
        }
      });
    }

  };
  generatePDF = (response) => {
    const doc = new jsPDF();
    const pdfTitle = "Claim Information";
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 15;
    const bottomMargin = 20;
    const borderPadding = 8;
    let yAxis = 25;

    // Draw border
    const drawBorder = () => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.rect(
        borderPadding,
        borderPadding,
        pageWidth - 2 * borderPadding,
        pageHeight - 2 * borderPadding
      );
    };

    // Check if we need new page
    const checkPageBreak = (neededSpace = 20) => {
      if (yAxis + neededSpace > pageHeight - bottomMargin) {
        doc.addPage();
        drawBorder();
        yAxis = 25;
      }
    };

    // Header
    drawBorder();
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    const titleWidth = doc.getTextWidth(pdfTitle);
    doc.text(pdfTitle, (pageWidth - titleWidth) / 2, 18);

    // Grey separation line below title
    doc.setDrawColor(180); // light gray
    doc.setLineWidth(0.5);
    doc.line(margin, 20, pageWidth - margin, 20);

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Generated on: ${moment().format("DD-MM-YYYY")}`,
      pageWidth - margin - 40,
      18
    );

    response.forEach((row, rowIndex) => {
      let reportingPersonName = row.reportingPersonName;

      if (rowIndex > 0) {
        doc.addPage();
        drawBorder();
        yAxis = 25;
      }

      // Salesperson Name (Blue + Underlined)
      doc.setFontSize(13);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0, 0, 255); // Blue
      doc.text(`Salesperson: ${row.name}`, margin, yAxis);

      // underline below salesperson text
      const salesTextWidth = doc.getTextWidth(`Salesperson: ${row.name}`);
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.5);
      doc.line(margin, yAxis + 2, margin + salesTextWidth, yAxis + 2);

      // Reset text color
      doc.setTextColor(0, 0, 0);
      yAxis += 10;

      // Label/value X positions
      const labelX = margin;
      const valueX = margin + 40;
      const col2LabelX = pageWidth / 2;
      const col2ValueX = pageWidth / 2 + 35;

      row.claimApplyHeader.forEach((claim) => {
        checkPageBreak(25);

        doc.setFontSize(11);

        // Claim Title
        doc.setFont("helvetica", "bold");
        doc.text("Claim Title:", labelX, yAxis);
        doc.setFont("helvetica", "normal");
        doc.text(claim.claimTitle, valueX, yAxis);

        // Date
        doc.setFont("helvetica", "bold");
        doc.text("Date:", col2LabelX, yAxis);
        doc.setFont("helvetica", "normal");
        doc.text(claim.date, col2ValueX, yAxis);

        yAxis += 6;

        // Total Amount
        doc.setFont("helvetica", "bold");
        doc.text("Total Amount:", labelX, yAxis);
        doc.setFont("helvetica", "normal");
        doc.text(`Rs. ${claim.claimAmount.toFixed(2)}`, valueX, yAxis);

        // Status
        doc.setFont("helvetica", "bold");
        doc.text("Status:", col2LabelX, yAxis);
        doc.setFont("helvetica", "normal");
        doc.text(claim.status, col2ValueX, yAxis);

        yAxis += 6;

        // Reporting To
        doc.setFont("helvetica", "bold");
        doc.text("Reporting To:", labelX, yAxis);
        doc.setFont("helvetica", "normal");
        doc.text(reportingPersonName, valueX, yAxis);

        yAxis += 10;

        // Claim Details
        claim.claimApplyDetail.forEach((detail, index) => {
          const claimAmt = "Rs." + detail.claimAmt.toFixed(2);
          const claimTypeName = detail.claimTypeName;

          const colWidth = (pageWidth - margin * 2) / 2;
          const xPosition = margin + (index % 2) * colWidth;
          const imageWidth = 65;
          const imageHeight = 55;
          const textSpacing = 6;

          checkPageBreak(imageHeight + 25);

          try {
            detail.attachFile &&
              detail.attachFile !== null &&
              detail.attachFile !== "" &&
              doc.addImage(
                imageUrl + detail.attachFile,
                "JPEG",
                xPosition,
                yAxis,
                imageWidth,
                imageHeight
              );
          } catch (e) {
            doc.setFont("helvetica", "italic");
            doc.text("Image not available", xPosition, yAxis + 10);
          }

          // clickable image
          doc.link(xPosition, yAxis, imageWidth, imageHeight, {
            url: imageUrl + detail.attachFile,
          });

          // base Y after image
          let baseTextY = yAxis + imageHeight;

          // ---------- NOTE ----------
          let noteY = baseTextY + 6;
          doc.setFont("helvetica", "normal");
          doc.setFontSize(11);
          doc.setTextColor(255, 0, 0);
          doc.text(
            "Note : Ctrl + Click to open attachment in new tab",
            xPosition,
            noteY
          );

          // ---------- CLAIM ----------
          let claimTextY = noteY + 6;
          doc.setFont("helvetica", "bold");
          doc.setFontSize(11);
          doc.setTextColor(0, 0, 0);
          doc.text(`${claimAmt} (${claimTypeName})`, xPosition, claimTextY);

          // ---------- REMARK ----------
          let remarkY = claimTextY + 6;
          doc.setFont("helvetica", "normal");
          doc.text(`Remark: ${detail.remark}`, xPosition, remarkY);


          if (index % 2 === 1 || index === claim.claimApplyDetail.length - 1) {
            yAxis += imageHeight + textSpacing * 4;
          }
        });


        // Separator line after each claim
        checkPageBreak(10);
        doc.setDrawColor(180); // light gray
        doc.setLineWidth(0.2);
        doc.line(margin, yAxis, pageWidth - margin, yAxis);
        yAxis += 8;
      });

      yAxis += 5; // space after salesperson
    });

    // Save file
    doc.save(`${pdfTitle}_${moment().format("DD-MM-YYYY")}.pdf`);
  };

  render() {
    const { dynamicMasterData } = this.state;

    console.log(dynamicMasterData);
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            getListById={this.getListById}
            dynamicMasterData={dynamicMasterData}
            showTitle={claimPdfJSON.showTitle}
            screenTitle={
              localStorage.getItem("showExcelInsteadOfClaimPdf")
                && localStorage.getItem("showExcelInsteadOfClaimPdf") == 1 ?
                "Claim Excel" : claimPdfJSON.screenTitle}
            fieldMeta={claimPdfJSON.fieldMeta}
            showCancel={claimPdfJSON.showCancel}
            apiBaseURL={claimPdfJSON.apiBaseURL}
            showSaveNextBtn={claimPdfJSON.showSaveNextBtn}
            onSave={this.onSearch}
            saveBtnText={"Download"}
            showSaveBtnMain={false}
            showSaveBtn={true}
          />
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stakeHolderTypeList: state.stockStakeHolderType,
  salesTeamList: state.salesExecutive,
});
const mapDispatchToProps = {
  showLoador,
  showNotification,
  getStockStakeHolderType,
  getClaimApply,
  getSalesExecutive,
};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimPdfMain);
